import * as XLSX from 'xlsx';

/**
 * Saves any table on screen as an Excel file.
 *
 * <p>`rows` are already-formatted objects - the keys become the column headers, so
 * each screen decides what its export looks like rather than dumping raw fields.
 */
export const exportToExcel = (rows: Record<string, unknown>[], fileName: string, sheetName = 'Report') => {
  if (!rows.length) return;
  const sheet = XLSX.utils.json_to_sheet(rows);
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, sheet, sheetName.slice(0, 31));
  const stamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(book, `${fileName}-${stamp}.xlsx`);
};
